import * as i0 from '@angular/core';
import { Directive, HostBinding, EventEmitter, ElementRef, Component, Inject, Input, Output, HostListener, Injectable, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, mixinOpenChange, Forward, Track, openChangeInput, openChangeChangeOutput, openChangeShownOutput, openChangeHiddenOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import { __decorate } from 'tslib';
import '@fa-switch-sharedservices/web-elements/components/toast/toast';

class FadvToastHeaderDirective extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.slotName = 'header';
    }
}
FadvToastHeaderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastHeaderDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
FadvToastHeaderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvToastHeaderDirective, selector: "fadv-toast-header", host: { properties: { "slot": "this.slotName" } }, exportAs: [""], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastHeaderDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'fadv-toast-header', exportAs: '' }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });

class FadvToastContentDirective extends FadvBaseComponent {
}
FadvToastContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastContentDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
FadvToastContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvToastContentDirective, selector: "fadv-toast-content", exportAs: [""], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastContentDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'fadv-toast-content', exportAs: '' }]
        }] });

class FadvToastComponent extends mixinOpenChange(FadvBaseComponent) {
    constructor(el) {
        super(el);
        this.duration = undefined;
        this.variant = 'primary';
        this.confirmed = new EventEmitter();
        this.dismissed = new EventEmitter();
    }
    toast() {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.toast();
    }
    _handleConfirmAction() {
        this.confirmed.emit();
    }
    _handleDismissAction() {
        this.dismissed.emit();
    }
}
FadvToastComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvToastComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvToastComponent, selector: "fadv-toast", inputs: { open: "open", duration: "duration", variant: "variant", confirmActionLabel: "confirmActionLabel", dismissActionLabel: "dismissActionLabel", heading: "heading", message: "message" }, outputs: { openChange: "openChange", shown: "shown", hidden: "hidden", confirmed: "confirmed", dismissed: "dismissed" }, host: { listeners: { "fadv-toast-confirmed": "_handleConfirmAction($event)", "fadv-toast-dismissed": "_handleDismissAction($event)" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvToastComponent.prototype, "duration", void 0);
__decorate([
    Forward()
], FadvToastComponent.prototype, "variant", void 0);
__decorate([
    Forward()
], FadvToastComponent.prototype, "confirmActionLabel", void 0);
__decorate([
    Forward()
], FadvToastComponent.prototype, "dismissActionLabel", void 0);
__decorate([
    Forward()
], FadvToastComponent.prototype, "heading", void 0);
__decorate([
    Forward()
], FadvToastComponent.prototype, "message", void 0);
__decorate([
    Track()
], FadvToastComponent.prototype, "confirmed", void 0);
__decorate([
    Track()
], FadvToastComponent.prototype, "dismissed", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-toast',
                    template: '<ng-content></ng-content>',
                    inputs: [openChangeInput],
                    outputs: [openChangeChangeOutput, openChangeShownOutput, openChangeHiddenOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { duration: [{
                type: Input
            }], variant: [{
                type: Input
            }], confirmActionLabel: [{
                type: Input
            }], dismissActionLabel: [{
                type: Input
            }], heading: [{
                type: Input
            }], message: [{
                type: Input
            }], confirmed: [{
                type: Output
            }], dismissed: [{
                type: Output
            }], _handleConfirmAction: [{
                type: HostListener,
                args: ['fadv-toast-confirmed', ['$event']]
            }], _handleDismissAction: [{
                type: HostListener,
                args: ['fadv-toast-dismissed', ['$event']]
            }] } });

class FadvToastService {
    createToastElement(options) {
        const toastElement = document.createElement('fadv-toast');
        if (options.variant)
            toastElement.variant = options.variant;
        if (options.message)
            toastElement.message = options.message;
        if (options.heading)
            toastElement.heading = options.heading;
        if (options.duration)
            toastElement.duration = options.duration;
        if (options.confirmActionLabel)
            toastElement.confirmActionLabel = options.confirmActionLabel;
        if (options.dismissActionLabel)
            toastElement.dismissActionLabel = options.dismissActionLabel;
        if (options.confirmCallback)
            toastElement.addEventListener('fadv-toast-confirmed', options.confirmCallback);
        if (options.dismissCallback)
            toastElement.addEventListener('fadv-toast-dismissed', options.dismissCallback);
        return toastElement;
    }
    createIcon(slotName, options) {
        const icon = document.createElement('fadv-icon');
        if (options.name)
            icon.name = options.name;
        if (options.library)
            icon.library = options.library;
        if (options.src)
            icon.src = options.src;
        if (options.foreground)
            icon.foreground = options.foreground;
        if (options.label)
            icon.label = options.label;
        if (options.background)
            icon.background = options.background;
        if (options.outline)
            icon.outline = options.outline;
        if (options.size)
            icon.size = options.size;
        icon.setAttribute('slot', slotName);
        return icon;
    }
    toast(options) {
        const toastOutlet = document.querySelector('fadv-toast-outlet');
        if (!toastOutlet) {
            console.error('FadvToastOutlet not found!');
            return;
        }
        const toastElement = this.createToastElement(options);
        if (options.prefixIcon)
            toastElement.append(this.createIcon('prefix', options.prefixIcon));
        if (options.suffixIcon)
            toastElement.append(this.createIcon('suffix', options.suffixIcon));
        toastOutlet.appendChild(toastElement);
        toastElement.toast();
    }
}
FadvToastService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FadvToastService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class FadvToastModule {
}
FadvToastModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvToastModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvToastModule, declarations: [FadvToastComponent, FadvToastHeaderDirective, FadvToastContentDirective], imports: [FadvCommonModule], exports: [FadvToastComponent, FadvToastHeaderDirective, FadvToastContentDirective] });
FadvToastModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastModule, providers: [FadvToastService], imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvToastModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvToastComponent, FadvToastHeaderDirective, FadvToastContentDirective],
                    imports: [FadvCommonModule],
                    providers: [FadvToastService],
                    exports: [FadvToastComponent, FadvToastHeaderDirective, FadvToastContentDirective],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvToastComponent, FadvToastContentDirective, FadvToastHeaderDirective, FadvToastModule, FadvToastService };
